import { fieldTypes } from "@constants/constant";
import { REGEX } from "@core/validation";
import { Field } from "@modules/dynamic-form-builder/model/formBuilderInterface";

export const NEWS_CONSTANTS = {
    NEW_NEWSLETTER: 'New Newsletter',
    NEWSLETTER_TITLE: 'Newsletter Title',
    NEWSLETTER_DESCRIPTION: 'Newsletter Description',
    NEWSLETTER_STATUS: 'Newsletter Status',
    NEWSLETTER_SUBSCRIBERS: 'Newsletter Subscribers',
    NEWSLETTER_CREATED_DATE: 'Newsletter Created Date',
    NEWSLETTER_EDIT: 'Newsletter Edit',
    NEWSLETTER_DELETE: 'Newsletter Delete',
    NEWSLETTER_CREATE: 'Newsletter Create',
    NEWSLETTERS: 'Newsletters',
    NO_NEWSLETTERS_YET: 'No Newsletters Yet',
    CREATE_NEWSLETTER: 'Create Newsletter',
    NO_NEWSLETTERS_FOUND: 'No Newsletters Found',
    CREATE_YOUR_FIRST_NEWSLETTER: 'Create your first newsletter to start engaging with your subscribers.',
    NEWSLETTER_RECIPIENTS: 'Newsletter Recipients',
    NO_RECIPIENTS_FOUND: 'No Recipients Found',
    RECIPIENT_NAME: 'Recipient Name',
    EMAIL: 'Email',
    DATE_JOINED: 'Date Joined',
    PURCHASE: 'PURCHASE',
    ALL_NEWSLETTERS_RECIPIENTS: 'All Newsletters Recipients',
    CANCEL: 'Cancel',
    DOWNLOAD_CSV: 'Download CSV',
    VIEW: 'View',
    SAVE_AS_DRAFT: 'Save as Draft',
    CONTINUE_EDITING: 'Continue Editing',
    SEND_TO_ALL_RECIPIENTS: 'Send to All Recipients',
    SEND_TO_ALL: 'Send to All',
    DO_YOU_WANT_TO_SAVE_THIS_NEWSLETTER_AS_A_DRAFT: 'Do you want to save this newsletter as a draft?',
    DELETE_NEWSLETTER: 'Delete Newsletter',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_NEWSLETTER: 'Are you sure you want to delete this newsletter?',
    DELETE: 'Delete',
    CLOSE: 'Close',
    NEWSLETTER_BODY_CONTENT: ' newsletter directly to your email inbox. There is no cost to receive and you can discontinue at anytime.',
    CURRENTLY_RECEIVING: 'You are currently receiving ',
    NEWSLETTER_EMAIL: 'Newsletter by Email.',
    JOIN_NEWSLETTER: 'Join Newsletter',
    SEARCH_NEWSLETTERS: 'Search Newsletters',
    PURCHASE_NEWSLETTER_FOR: 'Purchase Newsletter For',
    PURCHASE_NEWSLETTER_VIA_SUBSCRIPTION: 'Purchase Newsletter Via Subscription',
    PURCHASE_NEWSLETTER_BY_NFT: 'Purchase Newsletter By NFT',
    UNLOCK_NEWSLETTER_LOYALTY_PREFIX: 'Unlock with',
    UNLOCK_NEWSLETTER_WITH_POINTS_MODAL_HEADER: 'Unlock Newsletter with Points',
    DISCONTINUE_NEWSLETTER: 'Discontinue Newsletter',
    UNSUBSCRIBE_NEWSLETTER_BODY_CONTENT: 'Are you sure you want to discontinue receiving this newsltter?',
    YEAR: 'YEAR',
    NEW: 'NEW',
    RECIPIENTS: 'RECIPIENTS',
    COPY_NEWSLETTER: 'Copy Newsletter',
    ARE_YOU_SURE_YOU_WANT_TO_COPY_THIS_NEWSLETTER: 'Are you sure you want to copy this newsletter?',
    COPY: 'COPY',
    PREVIEW: 'NEWSLETTER PREVIEW',
    NEWSLETTER: 'Newsletter',
    EDIT: 'Edit',
    ADD: 'Add',
    SET_PRICING_OPTIONS_FOR_NEWSLETTER: 'Optional: Set Pricing Options for Newsletter',
    YOU_HAVENT_CREATED_ANY_SUBSCRIPTIONS_YET: "You haven't created any subscriptions yet",
    DO_YOU_WANT_TO_SEND_THIS_NEWSLETTER_TO_ALL: 'Do you want to email this newsletter to',
    PEOPLE: 'people',
    recipients: 'recipients?',
    NEWSLETTER_DISCONTINUED: 'Newsletter Discontinued',
    NO_LONGER_THE_NEWSLETTER: 'You will no longer receive this newsletter.',
    DISCONTINUE_FROM_NEWSLETTER: 'Discontinue Receiving ',
    YOU_CAN_UNSUBSCRIBE_FROM_A_CREATORS_NEWSLETTER_BY_CLICKING_THE_LINK_BELOW: 'You can discontinue receiving ',
    DISCONTINUE_TEXT: "newsletter by clicking the button below:",
    UNSUBSCRIBE: 'Unsubscribe',
    NOTIFICATIONS_NEWSLETTERS: 'Notifications & Newsletters',
    DESCRIPTION_PREVIEW: 'DESCRIPTION PREVIEW',
    LAST_SAVED: 'Last Saved: ',
    RESET: 'RESET',
    PREVIEW_BTN: 'SEE PREVIEW',
    DISCONTINUE: 'DISCONTINUE',
    JOIN: 'JOIN',
    CONTENT_NOT_ACTIVE: 'Content is no longer active',
    DISPLAY_NEWSLETTER: 'Display Newsletters on Profile Page',
    VIEW_NEWSLETTER_RECIPIENTS : 'VIEW NEWSLETTER RECIPIENTS',
    EMAIL_TO_ALL_RECIPIENTS: 'Email to Newsletter Recipients',
    EMAIL_NEWSLETTER: 'EMAIL NEWSLETTER',
    PUBLISHED_ON: 'Published on: ',
    DISCONTINUE_RECIEVING_NEWSLETTER: 'Discontinue Receiving Newsletter',
    DRAFT_ON: 'Last Saved on: ',
    SCHEDULED_PUBLISHED_ON: 'Scheduled to Publish on: ',
    NEWSLETTER_PREFERENCES: "NEWSLETTER PREFERENCES",
    PREFERENCES: 'PREFERENCES',
    NEWSLETTER_PREFERENCE_SMALL: "Newsletter Preferences",
    PREFERENCE_SMALL: 'Preferences',
    CONTINUE: 'CONTINUE',
    DRAFT_AUTO_SAVED: 'Draft Auto-Saved: ',
    LIVE: 'Live',
    LINK_IN_BIO: 'Link In Bio',
    ALL: 'All',
    MOBILE_LIST_TITLE: 'TITLE',
    MOBILE_LIST_STATUS: 'STATUS',
    MOBILE_LIST_ACTIONS: 'ACTIONS',
    MOBILE_LIST_SENT: 'SENT',
    MOBILE_LIST_OPENED: 'OPENED',
    MOBILE_LIST_UNLOCKED: 'UNLOCKED',
    NEWSLETTER_LIST_ARIA_EDIT: 'Edit newsletter',
    NEWSLETTER_LIST_ARIA_COPY: 'Copy newsletter',
    NEWSLETTER_LIST_ARIA_DELETE: 'Delete newsletter'
}

export const STATUS_FILTER = {
    type: fieldTypes.SELECT,
    label: '',
    name: 'filter',
    class: 'col-6',
    placeholder: '',
    options: [{ label: 'All', value: 'all' }, { label: 'Sent', value: 'SENT' },
    { label: 'Draft', value: 'DRAFT' },
    { label: 'Scheduled', value: 'SCHEDULED' }
    ],
    labelKey: 'label',
    valueKey: 'value'
};

export const FILTERS = {
    DRAFT: 'DRAFT',
    SENT: 'SENT',
    SCHEDULED: 'SCHEDULED',
    UPDATE: 'UPDATE',
    CREATE: 'CREATE',
    SEND: 'SEND',
    SCHEDULE: 'SCHEDULE',
    COPY: 'COPY'
}

export const NEWSLETTER_LIMIT = 20;

export const newsLetterFormField: Field = {
    type: fieldTypes.TEXT,
    label: 'Enter Your Email Address',
    name: 'email',
    class: 'col-12 col-lg-6',
    placeholder: 'Enter Email Address',
    validation: {
        required: {
            message: 'Email Address is required'
        },
        pattern: {
            value: REGEX.EMAIL,
            message: 'Please enter a valid email address'
        }
    }
};

export const yearField = {
    type: fieldTypes.SELECT,
    label: '',
    name: 'year',
    class: 'col-12',
    labelKey: 'label',
    valueKey: 'value',
    options: []
};

export const headingField = {
    type: fieldTypes.TEXT,
    label: '',
    placeholder: 'Add Newsletter Title here...',
    name: 'title',
    class: 'col-12',
    styleClass: 'mt-2',
    validation: {
        required: {
            message: 'Newsletter Title is required'
        },
        minlength: {
            value: 10,
            message: 'Title should be minimum 10 characters'
        },
        maxlength: {
            value: 100,
            message: 'Title Should be less than 100 characters'
        },
    }
}
